module.exports = __webpack_public_path__ + "static/media/sharebanner.48e8930c.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/sharebanner.png
// module id = 980
// module chunks = 0